import { API_CONSTANTS } from "../constants/search.constanst";
import { LocalStorageDataModel } from "../constants/local-storage-data-model";
import { getDataFromLocalStorage } from "../utils/globalUtilities";
import { postData } from "./global.service";
import { APIEnv } from "../interface/baseInterfaces";

export function createEndmileAPITrackObject(
  event: string,
  fields: any,
  userEmail?: string
) {
  let email =
    userEmail || getDataFromLocalStorage(LocalStorageDataModel.EMAIL) || "";

  let payload = {
    requestmethod: "AddSubscriberToList",
    details: {
      emailaddress: email,
      event_name: event,
      mailinglist: "1",
      format: "html",
      confirmed: "yes",
      customfields: { items: fields },
    },
  };
  return payload;
}
export function postEndmileAPIEventTrack(data: any) {
  postData(API_CONSTANTS.ENDMILE_EVENT_TRACK, data, APIEnv.ENDMILE)
    .then((res) => {})
    .catch((err) => {});
}

export function postNewEndmileAPIEventTrack(data: any) {
  postData(API_CONSTANTS.NEW_ENDMILE_EVENT_TRACK, data, APIEnv.ENDMILE)
    .then((res) => {})
    .catch((err) => {});
}

export function createNewEndmileAPITrackObject(
  event: string,
  fields: any,
  userEmail?: string,
  parentEventName?:string
) {
  let email =
    userEmail || getDataFromLocalStorage(LocalStorageDataModel.EMAIL) || "";

  let payload = {
    requestmethod: "AddSubscriberToList",
    details: {
      emailaddress: email,
      event_name: event,
      parent_event_name: parentEventName,
      customfields: { items: fields },
    },
  };
  return payload;
}